import React from 'react';

export const HeartFilled = ({ uuid }: { uuid?: string }) => {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_138_1018)">
        <path
          d="M1.46875 8.4062L7.125 13.6875C7.34375 13.9062 7.65625 14 8 14C8.3125 14 8.625 13.9062 8.84375 13.6875L14.5 8.4062C15.4375 7.5312 16 6.2812 16 4.9687V4.81245C16 2.62495 14.4062 0.749955 12.25 0.406205C10.8438 0.156205 9.375 0.624955 8.375 1.62495L8 1.99995L7.625 1.62495C6.59375 0.624955 5.15625 0.156205 3.71875 0.406205C1.5625 0.749955 0 2.62495 0 4.81245V4.9687C0 6.2812 0.53125 7.5312 1.46875 8.4062Z"
          fill={`url(#heartfilledgradient-${uuid})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`heartfilledgradient-${uuid}`}
          x1="0.292683"
          y1="3.69288"
          x2="15.4146"
          y2="3.69288"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB7085" />
          <stop offset="0.510417" stopColor="#EB5CBB" />
          <stop offset="1" stopColor="#D945EF" />
        </linearGradient>
        <clipPath id="clip0_138_1018">
          <rect width="16" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
